import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shorthandNumber',
})
export class ShorthandNumberPipe implements PipeTransform {
  transform(value: number): string {
    let result: string;

    if (Math.abs(value) >= 1_000_000) {
      result = (value / 1_000_000).toFixed(1) + 'M';
    } else if (Math.abs(value) >= 1_000) {
      result = (value / 1_000).toFixed(1) + 'K';
    } else {
      return value.toString();
    }

    // Remove .0 from the result if exists
    return result.replace('.0', '');
  }
}
